import React from "react";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

export interface MessageCardProps {
	// message to display
	message: string;
	// optional card elevation (shadow size)
	elevation?: number;
	// defaults to center
	textAlign?: "left" | "center" | "right";
	// box padding, defaults to 2
	padding?: number;
}

/**
 * Reusable message display
 * @param props
 */
export const MessageCard = (props: MessageCardProps) => {
	return (
		<div>
			<Paper elevation={props.elevation || 0}>
				<Box p={props.padding === undefined ? 2 : props.padding}>
					<Typography component="p" align={props.textAlign || "center"} color="textSecondary" variant="body1">
						{props.message}
					</Typography>
				</Box>
			</Paper>
		</div>
	);
};
